<sb-dialog-content class="pb-0 pt-10">
  <sb-empty-state
    [title]="data.title"
    [description]="data.description"
    [icon]="data.icon"
    [richIcon]="data.richIcon ?? false"
    [contentSize]="'auto'"
  />
</sb-dialog-content>

<sb-dialog-footer>
  @if (data.secondary) {
    <sb-dialog-footer-actions [align]="'start'">
      <a sb-button [color]="'transparent'" target="_blank" [attr.href]="data.secondary.href">
        {{ data.secondary.text || ('Learn more' | translate) }}
      </a>
    </sb-dialog-footer-actions>
  }

  <sb-dialog-footer-actions [align]="'end'">
    <button sb-button [color]="'primary'" (click)="data.primary?.onClick?.(); onPrimaryAction()">
      {{ data.primary?.text || ('Okay' | translate) }}
    </button>
  </sb-dialog-footer-actions>
</sb-dialog-footer>
